import React from "react";

const MenuRoute = ({ children }) => {
    return children;
};

export default MenuRoute;
